import React from "react";
import { TextField, MenuItem } from "@mui/material";
import { useFormikContext, getIn } from "formik";

const FormikInput = ({
  name,
  label,
  type = "text",
  multiline = false,
  rows = 1,
  required = false,
  numericOnly = false,
  decimalOnly = false,
  select = false,
  options = [],
  ...props
}) => {
  const { values, errors, touched, handleBlur, setFieldValue } = useFormikContext();

  const fieldValue = getIn(values, name);
  const fieldError = getIn(errors, name);
  const fieldTouched = getIn(touched, name);

  const handleInputChange = (e) => {
    let value = e.target.value;

    if (select) {
      setFieldValue(name, value);
      return;
    }

    if (numericOnly) {
      value = value.replace(/\D/g, "");
    }

    if (decimalOnly) {
      value = value.replace(/[^0-9.]/g, "");

      // remove leading 0 when typing new number
      if (fieldValue === "0" && !value.startsWith(".")) {
        value = value.replace(/^0+/, "");
      }

      // allow only one dot
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      // 👉 limit to 2 decimal places
      if (value.includes(".")) {
        const [intPart, decimalPart] = value.split(".");
        value = intPart + "." + decimalPart.slice(0, 2);
      }
    }

    setFieldValue(name, value);
  };

  return (
    <TextField
      fullWidth
      name={name}
      label={
        <>
          {label} {required && <span style={{ color: "#d32f2f" }}>*</span>}
        </>
      }
      type={type}
      value={fieldValue || ""}
      onChange={handleInputChange}
      onBlur={handleBlur}
      multiline={multiline}
      rows={multiline ? rows : undefined}
      error={fieldTouched && Boolean(fieldError)}
      helperText={fieldTouched && fieldError}
      size="small"
      select={select}
      {...props}
    >
      {select &&
        options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
    </TextField>
  );
};

export default FormikInput;
